export const PARTNER_SUPPORT_URL = 'https://partners.atlassian.com/support';
export const PARTNER_SUPPORT_STG_URL = 'http://partners.stg.internal.atlassian.com/support';
export const ATLASSIAN_START_URL = 'https://start.atlassian.com';
export const ATLASSIAN_START_STG_URL = 'https://start.stg.atlassian.com';
export const PARTNER_PORTAL_URL = 'https://atlassianpartners.atlassian.net/';
export const RESEARCH_GROUP_URL = 'https://www.atlassian.com/research-group';
export const PARTNER_MANAGED_SUBSCRIPTIONS_URL = 'https://admin.atlassian.com/partner-managed-subscriptions';
export const PARTNER_MANAGED_SUBSCRIPTIONS_STG_URL = 'https://admin.stg.atlassian.com/partner-managed-subscriptions';
export const CREDIT_REQUEST_UI_STG_URL = 'https://credit-request-ui.stg-east.frontend.public.atl-paas.net';
export const CREDIT_REQUEST_UI_URL = 'https://credit-request.atlassian.com';
export const RESOURCE_HUB_URL =
  'https://atlassianpartners.atlassian.net/wiki/spaces/resources/pages/254378157/Partner+Purchasing+Center+Hub';
export const GSAC_BASE_STG_URL = 'https://getsupport.stg.internal.atlassian.com';
export const GSAC_BASE_URL = 'https://getsupport.atlassian.com';
export const WHAT_IS_NEW_URL =
  'https://atlassianpartners.atlassian.net/wiki/spaces/resources/pages/504987747/PPC+Updates';
export const ATLASSIAN_SUPPORT_SANDBOX_DELETION_URL_STAGING =
  'https://support.stg.internal.atlassian.com/organization-administration/docs/delete-a-sandbox';
export const ATLASSIAN_SUPPORT_SANDBOX_DELETION_URL =
  'https://support.atlassian.com/organization-administration/docs/delete-a-sandbox';
